module.exports = __webpack_public_path__ + "media/bootstrap-icons/geo-b97293b5.svg";